<template>
  <v-layout row>
    <v-flex xs3 v-for="item in list" :key="item.field" class="pb-0">
      <v-text-field
        :label="item.label"
        :value="data[item.field]"
        hide-details
        @change="$emit('change', { field: item.field, event: $event })"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ExaminationTimeField',
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      
    }
  },

  computed: {
    ...mapGetters('examinations', [, 'getExaminationData']),
    list() {
      return [
        {
          field: 'insertionTime',
          label: this.$t('common.insertion_time'),
        },
        {
          field: 'proximalColonWithTime',
          label: this.$t('common.proximal_colon_withdrawal_time'),
        },
        {
          field: 'withdrawTime',
          label: this.$t('common.withdraw_time'),
        },
        {
          field: 'totalExamTime',
          label: this.$t('common.total_exam'),
        },
      ]
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/components/textInputsTextfield.scss';
</style>
